import { useMutation } from "@tanstack/react-query"
import type {
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query"

import client from "~/backend/axiosClient"

import type {
  RevertImportMutationRequest,
  RevertImportMutationResponse,
} from "../types/RevertImport"

type RevertImportClient = typeof client<
  RevertImportMutationResponse,
  Error,
  RevertImportMutationRequest
>
type RevertImport = {
  data: RevertImportMutationResponse
  error: Error
  request: RevertImportMutationRequest
  pathParams: never
  queryParams: never
  headerParams: never
  response: Awaited<ReturnType<RevertImportClient>>
  client: {
    parameters: Partial<Parameters<RevertImportClient>[0]>
    return: Awaited<ReturnType<RevertImportClient>>
  }
}
/**
 * @summary Revert import
 * @link /v1/product/revert-import
 */
export function useRevertImport(
  options: {
    mutation?: UseMutationOptions<
      RevertImport["response"],
      RevertImport["error"],
      RevertImport["request"]
    >
    client?: RevertImport["client"]["parameters"]
  } = {}
): UseMutationResult<
  RevertImport["response"],
  RevertImport["error"],
  RevertImport["request"]
> {
  const { mutation: mutationOptions, client: clientOptions = {} } =
    options ?? {}
  return useMutation<
    RevertImport["response"],
    RevertImport["error"],
    RevertImport["request"]
  >({
    mutationFn: async (data) => {
      const res = await client<
        RevertImport["data"],
        RevertImport["error"],
        RevertImport["request"]
      >({
        method: "post",
        url: `/v1/product/revert-import`,
        data,
        ...clientOptions,
      })
      return res
    },
    ...mutationOptions,
  })
}
